export enum Timezone {
  UTC = 'UTC',
  US_EASTERN = 'US/Eastern',
  US_CENTRAL = 'US/Central',
  US_MOUNTAIN = 'US/Mountain',
  US_PACIFIC = 'US/Pacific',
  US_HAWAII = 'US/Hawaii',
}

export type AnalyticsSettingsData = {
  timezone: Timezone;
};

export type UseAnalyticsSettingsParams = {
  groupId: string;
};

export type AnalyticsSettingsQueryKey = readonly [
  'groups',
  'analyticsSettings',
  UseAnalyticsSettingsParams,
];

export type UpdateAnalyticsSettingsQueryVars = {
  timezone: Timezone;
};
